<div class="confirm-dialog-container">
  <div class="icon-container">
    @if (title === 'Software Update') {
      <mat-icon
        class="software-update-icon"
        fontSet="material-symbols"
        [ngStyle]="{ color: accessibilityMode ? 'navy' : '#65C9DA' }"
        >autorenew</mat-icon
      >
    }
    @if (title === 'Log Out') {
      <mat-icon
        class="logout-icon"
        fontSet="material-symbols"
        [ngStyle]="{ color: accessibilityMode ? 'navy' : '#65C9DA' }"
        >exit_to_app</mat-icon
      >
    }
    @if (title === 'Disconnected') {
      <mat-icon
        class="disconnected-icon"
        fontSet="material-symbols-rounded"
        [ngStyle]="{ color: accessibilityMode ? 'navy' : '#FFBD28' }"
        >warning_amber</mat-icon
      >
    }
  </div>

  <h2 mat-dialog-title class="confirm-dialog-title">{{ title }}</h2>
  <mat-dialog-content
    class="confirm-dialog-content"
    [class.disconnected-msg]="disconnectedMsg === true"
  >
    {{ message }}
  </mat-dialog-content>
  <mat-dialog-actions
    *ngIf="buttons.length === 0"
    class="logout-actions-container mat-actions-firefox"
  >
    <button
      mat-button
      color="primary"
      data-cy="popup-button"
      class="popup-cancel-button"
      style="background-color: #ffffff"
      (click)="confirm(true)"
    >
      Yes
    </button>
    <button
      mat-flat-button
      color="primary"
      class="popup-button"
      style="color: #ffffff"
      data-cy="no-button"
      [ngStyle]="{ 'background-color': accessibilityMode ? 'navy' : '#65C9DA' }"
      (click)="confirm(false)"
    >
      No
    </button>
  </mat-dialog-actions>

  <mat-dialog-actions *ngIf="buttons.length > 0">
    <button
      *ngFor="let button of buttons; trackBy: trackByIndex"
      mat-flat-button
      color="primary"
      [attr.data-cy]="button.text + '-button'"
      [ngClass]="button.buttonClass"
      [ngStyle]="{ 'background-color': accessibilityMode ? 'navy' : '#65C9DA' }"
      (click)="confirm(button.returnValue)"
    >
      {{ button.text }}
    </button>
  </mat-dialog-actions>
</div>
